<template>
  <div>
    <v-autocomplete
      v-model="select"
      append-icon="place"
      label="Seleccione un Lugar"
      :search-input.sync="search"
      :items="items"
      :loading="loading"
      :multiple="multiple"
      :chips="chips"
      :small-chips="chips"
      :deletable-chips="chips"
      :menu-props="{
        closeOnClick: true,
        closeOnContentClick: true,
      }"
      @change="change"
      outlined
      clearable
      cache-items
      hide-no-data
      hide-details
    >
      <template v-slot:selection="data" v-if="chips">
        <v-chip
          v-bind="data.attrs"
          :input-value="data.selected"
          @click="data.select"
          @click:close="remove(data.item)"
          class="mt-1 ml-0 mr-1 pl-0"
          close
          small
        >
          <v-avatar
            class="mr-1"
            size="16"
            :color="data.item.value.startsWith('dep') ? 'info' : 'secondary'"
          >
            <span class="white--text">
              {{ data.item.value.startsWith("dep") ? "D" : "M" }}
            </span>
          </v-avatar>
          {{ data.item.text }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <div>
          <div class="body-2">
            {{ data.item.text }}
          </div>
          <div
            class="text--secondary"
            style="font-size: 12px"
            v-if="search && data.item.group"
          >
            {{ data.item.group }}
          </div>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import _findindex from "lodash.findindex";
import _flatten from "lodash.flatten";
import { COLOMBIA } from "@/commons/constants.js";
export default {
  data() {
    return {
      loading: false,
      search: "",
      items: [],
      select: [],
    };
  },
  props: {
    maxNameLength: {
      type: Number,
      default: () => 40,
    },
    multiple: {
      type: Boolean,
      default: () => true,
    },
    chips: {
      type: Boolean,
      default: () => true,
    },
  },
  mounted() {
    const placeNames = new Set();
    for (const [key, entries] of Object.entries(COLOMBIA)) {
      this.items.push({ header: key });
      entries.forEach((element) => {
        if (placeNames.has(element)) {
          this.items.push({
            group: key,
            text: `${element} - ${key}`,
            value: `mun@${key}@${element}`,
          });
        } else {
          this.items.push({
            group: key,
            text: element,
            value: `mun@${key}@${element}`,
          });
        }
        placeNames.add(element);
      });
    }

    this.items.push({ header: "Departamentos" });
    this.items.push({ divider: true });
    Object.keys(COLOMBIA).forEach((element) => {
      this.items.push({
        text: `Departamento ${element}`,
        value: `dep@${element}`,
      });
    });
  },
  methods: {
    change(v) {
      if (this.multiple) {
        const value = v.map((entry) => {
          if (entry.startsWith("dep")) {
            const [prefix, departamento] = entry.split("@");
            console.log(prefix, departamento);
            return {
              name: "state",
              value: departamento,
            };
          } else if (entry.startsWith("mun")) {
            const [prefix, departamento, municipio] = entry.split("@");
            console.log(prefix, departamento, municipio);
            return [
              {
                name: "city",
                value: municipio,
              },
            ];
          }
        });
        this.$emit("change", _flatten(value));
        this.search = "";
      } else {
        if (v.startsWith("dep")) {
          const [prefix, departamento] = v.split("@");
          console.log(prefix, departamento);
          this.$emit("change", [
            {
              name: "state",
              value: departamento,
            },
          ]);
        } else if (v.startsWith("mun")) {
          const [prefix, departamento, municipio] = v.split("@");
          console.log(prefix, departamento, municipio);
          this.$emit("change", [
            {
              name: "city",
              value: municipio,
            },
          ]);
        }
        this.search = "";
      }
    },
    remove(item) {
      const index = _findindex(this.select, function (o) {
        return o == item.value;
      });
      if (index >= 0) this.select.splice(index, 1);
      this.change(this.select);
    },
  },
  watch: {
    preSelected(val) {
      console.log(val);
      if (this.preSelected) {
        this.select = this.preSelected;
      }
    },
  },
};
</script>